<script setup lang="ts">
import type { TSectionApplianceCategory } from "#/ui-kit/components/section/appliances/section-appliance-category.types";

import { getCategoryTranslationKey } from "#/ui-kit/components/section/appliances/section-appliance-category-utils";
import { useCommonFrontendIntl } from "#/ui-kit/locales/typed-intl";
import { DATA_TEST_IDS } from "@voltalis/frontend-utils";

const props = defineProps<{
  applianceCategory: TSectionApplianceCategory;
}>();

const { t } = useCommonFrontendIntl();
</script>

<template>
  <span :data-test-id="DATA_TEST_IDS.components.sectionApplianceText.component">{{
    t(getCategoryTranslationKey(applianceCategory))
  }}</span>
</template>
